export default __webpack_public_path__ + "static/11_30-b7dd2fff761dd35232a0ebe50346001c.png";